const state = {
  project_modal_id: null,
  project_modal_view: null,
};

const getters = {
  project_modal_id(state) {
    return state.project_modal_id;
  },
  project_modal_view(state) {
    return state.project_modal_view;
  },
};

const mutations = {
  setProjectModalID(state, payload) {
    state.project_modal_id = payload;
  },
  setProjectModalView(state, payload) {
    state.project_modal_view = payload;
  },
};

const actions = {
  setProjectModalID(context, payload) {
    context.commit('setProjectModalID', payload);
  },
  setProjectModalView(context, payload) {
    context.commit('setProjectModalView', payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
